import AuthService from "./auth.service";
import http from "./http-common";

const token = AuthService.getToken();

const getAllEmployeeList = () => {
  return http.get("/HrEmployee/GetEmpList", {
    headers: { Authorization: "Bearer " + token },
  });
};

const uploadEmployee = (data) => {
  return http.post("/User/UploadCSV", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const EmployeeService = {
  getAllEmployeeList,
  uploadEmployee,
};

export default EmployeeService;
